import * as Excel from 'exceljs/dist/exceljs';

// constant
const ALLOWED_REGISTER = ["1001", "1002", "1004", "1018", "1030", "1036"];

class ReportFormatters {
  static async analytic(file) {
    const analyticReport = [];

    const workbook = new Excel.Workbook();
    const reader = new FileReader();
    const archive = file[0];
    const blob = new Blob([archive], {type: archive.type});
    reader.readAsArrayBuffer(blob);

    return new Promise((resolve) => {
      reader.onload = () => {
        const buffer = reader.result;

        workbook.xlsx.load(buffer).then((workbook) => {
          workbook.eachSheet((sheet, id) => {
            sheet.eachRow((row, rowIndex) => {
              if (rowIndex > 1) {
                const line = row.values;

                const regex = /\d+/i;
                const parsedValue = regex.exec(line[7]) || ["0"];

                const analytic = {
                  date: line[1],
                  operation: line[2],
                  client: line[3],
                  store: line[4],
                  store_used: line[5],
                  voucher_id: String(line[6]).trim(),
                  value: Number(parsedValue[0]),
                };

                if (
                  analytic.operation === "Utilização" ||
                  analytic.operation === "Ativação"
                ) {
                  analyticReport.push(analytic);
                }
              }

              resolve(analyticReport);
            });
          });
        });
      };
    });
  }

  static async usedVouchers(file) {
    const usedVouchers = [];

    const workbook = new Excel.Workbook();
    const reader = new FileReader();
    const archive = file[0];
    const blob = new Blob([archive], {type: archive.type});

    reader.readAsArrayBuffer(blob);

    return new Promise((resolve) => {
      reader.onload = () => {
        const buffer = reader.result;

        workbook.xlsx.load(buffer).then((workbook) => {
          workbook.eachSheet((sheet, tab) => {
            sheet.eachRow(async (row, rowIndex) => {
              if (rowIndex > 1) {
                const line = row.values;

                const usedVoucher = {
                  store: line[2], // Centro
                  transaction: line[9], // Nº Transação
                  date: line[3], // Data Lançamento
                  register: line[10].trim(), // Tipo Transação
                  type: String(line[12]).trim(), // Tipo Fidelidade
                  voucher_id: String(line[13]).trim(), // Nº Voucher
                  value: Number(line[27]), // Valor Meio Pagto
                };

                if (usedVoucher.type === 'FIDELIDADE UTILIZAÇÃO') {
                  if (ALLOWED_REGISTER.includes(usedVoucher.register)) {
                    usedVouchers.push(usedVoucher);
                  }
                }
              }

              resolve(usedVouchers);
            });
          });
        });
      };
    });
  }

  static async activatedVouchers(file) {
    const activatedVouchers = [];

    const workbook = new Excel.Workbook();
    const reader = new FileReader();
    reader.readAsArrayBuffer(file[0]);

    return new Promise((resolve) => {
      reader.onload = () => {
        const buffer = reader.result;

        workbook.xlsx.load(buffer).then((workbook) => {
          workbook.eachSheet((sheet, tab) => {
            sheet.eachRow((row, rowIndex) => {
              if (rowIndex > 1) {
                const line = row.values;

                const activatedVoucher = {
                  store: line[2], // Centro
                  transaction: line[9], // Nº Transação
                  date: line[3], // Data Lançamento
                  operation: String(line[12]).trim().toUpperCase(), // Tipo Fidelidade
                  voucher_id: String(line[13]).trim(), // Nº Voucher
                  value: Number(line[27]), // Valor Meio Pagto
                };

                if (activatedVoucher.operation === "FIDELIDADE ATIVAÇÃO") {
                  activatedVouchers.push(activatedVoucher);
                }
              }

              resolve(activatedVouchers);
            });
          });
        });
      };
    });
  }
}

export { ReportFormatters };
